import { createMuiTheme } from "@material-ui/core";
import colors from "styles/colors.module.scss";

const color = colors.lightBlue.includes("#") ? colors.lightBlue : "#fff";

const tableTheme = createMuiTheme({
  palette: {
    primary: {
      main: color,
    },
    secondary: {
      main: color,
    },
  },
  overrides: {
    MuiTableCell: {
      root: {
        borderBottom: 0,
      },
    },
    MuiInput: {
      underline: {
        "&:before": {
          borderBottom: 0,
        },
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: "1.2rem",
      },
    },
    MuiTableHead: {
      root: {
        position: "sticky",
      },
    },
    MuiCheckbox: {
      indeterminate: {
        color: colors.lightBlue
      }
    }
  },
});

export default tableTheme;
